import {makeFormData} from "../modals/general-form-maker";
import axios from "axios";
import {pushAfterInfo} from "JQueryScripts/dataLayer/pushAfterInfo";
import {pushEventAddPaymentInfo} from "JQueryScripts/data-layer-handlers/push-event-add-payment-info";

const url = '/rest/payments/manage/get-token';
const urlFromProfile = '/rest/payments/manage/update-payment-info';
const urlInvoice = '/rest/payments/manage/generate-invoice';
const urlRefund = '/rest/user/license/refund';
const urlVatRequiredCountries = '/rest/payments/vat-required-countries';

const formBusiness = 'payment-info-form--business';
const personal = 'personal';
const business = 'business';

const hasError = 'has-error';
const areaInvalid = 'aria-invalid';

let vatRequiredCountries;

const expandCompanyInformationForm = function () {
    $('form.company-information').parent().removeClass('hidden');
    $('.profile-section .edit-info-button').addClass('hidden');
};

const collapseCompanyInformationForm = function () {
    $('form.company-information').parent().addClass('hidden');
    $('.profile-section .edit-info-button').removeClass('hidden');
};

export const bindEventsOnPayment = () => {
    axios.get(urlVatRequiredCountries)
      .then((response) => {
          if (Array.isArray(response.data)) {
              vatRequiredCountries = [...response.data];
          } else {
              console.error('Wrong vat-required-countries response format');
          }
      }).catch((error) => {console.error(error)}
    );

    $('.company-information-submit').click(function (e) {
        e.preventDefault();

        const form = $(this).parents('form.company-information');
        const isWithoutPayment = form.hasClass('without-payment');

        let canSend = true;

        if (!isWithoutPayment) {
            const $quantityInput = $('#license-quantity').parent();

            if ($quantityInput.hasClass(hasError)) {
                canSend = false;
            }
        }

        form.find('input.required').each(function () {
            if ($(this).val() === '') {
                canSend = false;
                $(this).parents('.form-group').addClass(hasError);
                $(this).attr(areaInvalid, true);
                $(this).parents('.form-group').find('.help-block').text($(this).parents('form').data('error-text'));
                $(this).parents('.form-group').find('.help-block').show();
            }
        });

        form.find('input.company-information-required').each(function () {
            $(this).parents('.form-group').removeClass(hasError);
            $(this).removeAttr(areaInvalid);
            $(this).parents('.form-group').find('.help-block').text($(this).parents('form').data('error-text'));
            $(this).parents('.form-group').find('.help-block').hide();
        });

        form.find('input.company-information-required').each(function () {
            const country = $(this).closest('form').find('#company-information-business-country').val();
            const isVatIdRequired = !Array.isArray(vatRequiredCountries) || vatRequiredCountries.includes(country);

            if ($(this).val() === '' && isVatIdRequired) {
                console.log('failed!')
                canSend = false;
                $(this).parents('.form-group').addClass(hasError);
                $(this).attr(areaInvalid, true);
                $(this).parents('.form-group').find('.help-block').text($(this).parents('form').data('error-text'));
                $(this).parents('.form-group').find('.help-block').show();
            }
        });

        if (canSend === false) {
            return;
        }

        const $parent = $(this).parents('form.company-information').parent()
        let data = makeFormData($parent);

        for (const i in data) {
            if (i.indexOf('[') !== -1) {
                const matches = i.match(/(.+?)\[(.+)\]/i);

                const formName = matches[1];
                const name = matches[2];

                if (data[formName] === undefined) {
                    data[formName] = {};
                }

                data[formName][name] = data[i];
                delete data[i];
            }
        }

        const formName = isWithoutPayment ? 'ProfileUserCompanyInformationForm' : 'UserCompanyInformationForm';
        data[formName].lastPurchaseType = getPurchaseType($parent);

        axios.post(isWithoutPayment ? urlFromProfile : url, data)
            .then((response) => {
                if (isWithoutPayment) {
                    collapseCompanyInformationForm();
                    return;
                }

                if (response.data.redirect !== undefined) {
                    window.location.href = response.data.redirect;
                }

                if (response.data.url !== undefined) {
                    pushAfterInfo(response.data.isPerson, response.data.type, response.data.planType);
                    pushEventAddPaymentInfo(response.data.isPerson, response.data.type, response.data.planType);
                    window.location.href = response.data.url;
                }
            }).catch((error) => {
                console.log(error);
            }
        );
    });

    $('#send-request-pdf-invoice').click(function () {
        axios.get(urlInvoice)
            .then((response) => {
                $(this).remove();
            }).catch((error) => {
        });
    });

    $('.submit-payment-refund').click(function () {
        const license_id = $(this).data('id');

        axios.post(urlRefund, { license_id })
            .then(() => {
                window.location.reload();
            }).catch((error) => {
                console.log(error);
            },
        );
    });

    $('.profile-section .edit-info-button').on('click', expandCompanyInformationForm);

    $('form.company-information .hide-form-button').on('click', collapseCompanyInformationForm);
};

function getPurchaseType($parent) {
    if ($parent.hasClass(formBusiness)) {
        return business;
    }

    return personal;
}
